/***********************************************************/
/*    para usar imagenes primero tienes que importarlas    */
/***********************************************************/
import scss from './sass/main.scss'
// import logo from './assets/img/boilerplate.png'

require.context('./assets/img', true, /\.(png|jpe?g|gif|svg|webp)$/);


/***********************************************************/
/*             importamos archivos javascript              */
/***********************************************************/
import { menuButton } from './js/menu'
import { expandCollapse } from './js/expandCollapse'
import { arrow } from './js/arrow'

menuButton()
expandCollapse()
arrow()

